var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"align-self":"center","align":"center"}},[_c('v-img',{attrs:{"src":require('@/assets/logo.svg'),"max-width":"200"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }